import {
  Button,
  DatePicker,
  Form,
  Icon,
  Input,
  InputNumber,
  message,
  Modal,
  Select,
  Upload
} from 'antd';
import {FormComponentProps} from 'antd/lib/form/Form';
import TextArea from 'antd/lib/input/TextArea';
import {inject, observer} from 'mobx-react';
import * as moment from 'moment';
import * as React from 'react';
import {Helmet} from 'react-helmet';
import ReactMapGL, {Marker, NavigationControl} from 'react-map-gl';
import {RouteComponentProps} from 'react-router';
import Card, {CardBody, CardHeader} from '../../components/Card';
import Layout, {Main} from '../../components/Layout';
import {RolesListModelType} from '../../models/RolesListModel';
import {RoleModelType} from '../../models/RolesListModel/RolesListModel';
import {UserDetailModelType} from '../../models/UserDetailModel';

const Option = Select.Option;

// tslint:disable
interface UserFormProps
  extends FormComponentProps,
    RouteComponentProps<{userId: string}> {
  userDetail: UserDetailModelType;
  rolesList: RolesListModelType;
}

const MAPBOX_TOKEN =
  (window as any).MAPBOX_TOKEN || process.env.REACT_APP_MAPBOX_TOKEN;
const UPLOAD_ENDPOINT =
  (window as any).UPLOAD_ENDPOINT || process.env.REACT_APP_UPLOAD_ENDPOINT;

interface EditUserFormState {
  viewport: any;
  latitude: number;
  longitude: number;
  previewVisible: boolean;
  previewImage: string;
  fileList: any;
}

@inject('userDetail', 'rolesList')
@observer
export class EditUserForm extends React.Component<
  UserFormProps,
  EditUserFormState
> {
  constructor(props: UserFormProps) {
    super(props);
    this.state = {
      latitude: 37.776021,
      longitude: -122.4171949,
      viewport: {
        height: 400,
        width: 400,
        zoom: 12,
        latitude: 37.776021,
        longitude: -122.4171949
      },
      previewVisible: false,
      previewImage: '',
      fileList: []
    };
  }

  public updateViewport = (viewport: any) => {
    this.setState(prevState => ({
      viewport: {...prevState.viewport, ...viewport}
    }));
  };

  private getUploadEndpoint() {
    console.log(UPLOAD_ENDPOINT);
    return `${UPLOAD_ENDPOINT}/pictures/user`;
  }

  public resize = () => {
    this.setState(prevState => ({
      viewport: {
        ...prevState.viewport,
        height: 400,
        width: window.innerWidth - 300
      }
    }));
  };

  private get _withInjectedProps() {
    return this.props as UserFormProps;
  }

  private get _userId() {
    return Number(this._withInjectedProps.match.params.userId);
  }

  async componentDidMount() {
    await this._withInjectedProps.userDetail.getUser(this._userId);
    this._withInjectedProps.rolesList.loadEntries('app');

    const {user} = this._withInjectedProps.userDetail;
    if (user) {
      let latitude = user.latitude ? user.latitude : this.state.latitude;
      let longitude = user.longitude ? user.longitude : this.state.longitude;
      this.setState({
        latitude: latitude,
        longitude: longitude
      });
      this.setState(prevState => ({
        viewport: {
          ...prevState.viewport,
          latitude: latitude,
          longitude: longitude
        }
      }));

      if (user.avatar) {
        this.setState({
          fileList: [
            {
              uid: '-1',
              name: 'image.png',
              status: 'done',
              url: user.avatar
            }
          ]
        });
      }
    }
    window.addEventListener('resize', this.resize);
    this.resize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  handleSubmit = (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }
      if (values.birthDay) {
        values.birthDay = values.birthDay.format('YYYY-MM-DD');
      }
      console.log(values);
      this._withInjectedProps.userDetail.updateUser(
        this._userId,
        values,
        this.callbackUpdate
      );
    });
  };

  callbackUpdate(err: boolean, msg: string) {
    if (err) {
      message.error(msg);
    } else {
      message.info(msg);
    }
  }

  buildSelectRole(role: RoleModelType | undefined) {
    const {entries: roleEntries} = this._withInjectedProps.rolesList;
    const roleArray = Array.from(roleEntries.values());
    if (!role) {
      return undefined;
    }

    return (
      <Select>
        {roleArray.map((r, idx) => {
          return (
            <Option key={String(idx)} value={r.id}>
              {r.name}
            </Option>
          );
        })}
      </Select>
    );
  }

  handleDragEndMarker = (event: any) => {
    console.log(event);
    const {setFieldsValue} = this.props.form;
    const lngLat = event.lngLat;
    setFieldsValue({
      latitude: lngLat[1],
      longitude: lngLat[0]
    });

    this.setState({
      latitude: lngLat[1],
      longitude: lngLat[0]
    });
  };

  getBase64(file: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result) resolve(reader.result);
      };
      reader.onerror = error => reject(error);
    });
  }

  handleCancel = () => this.setState({previewVisible: false});

  handlePreview = async (file: any) => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true
    });
  };

  handleChange = ({fileList, file}: any) => {
    this.setState({fileList});

    if (file.status === 'done') {
      const {setFieldsValue} = this.props.form;
      const url = file.response.url;
      if (!url) {
        message.error('Upload image failure');
        return;
      }
      this.setState({
        fileList: [
          {
            uid: file.uid,
            name: file.name,
            status: 'done',
            url: url
          }
        ]
      });

      setFieldsValue({avatar: url});
    }
  };

  handleUploadFile = (obj: any) => {
    console.log(obj);
  };

  renderUploadButton() {
    const {previewVisible, previewImage, fileList} = this.state;
    const uploadButton = (
      <Button>
        <Icon type="upload" /> Change
      </Button>
    );
    return (
      <React.Fragment>
        <Upload
          action={this.getUploadEndpoint()}
          listType="picture-card"
          fileList={fileList}
          onPreview={this.handlePreview}
          onChange={this.handleChange}
        >
          {uploadButton}
        </Upload>
        <Modal
          visible={previewVisible}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt="example" style={{width: '100%'}} src={previewImage} />
        </Modal>
      </React.Fragment>
    );
  }
  renderFormEdit() {
    const {getFieldDecorator} = this.props.form;
    const {user} = this.props.userDetail;
    const {viewport} = this.state;
    if (!user) {
      return undefined;
    }

    const formItemLayout = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 4}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 20}
      }
    };

    return (
      <Form layout="vertical" onSubmit={this.handleSubmit}>
        <Form.Item {...formItemLayout} label="Avatar">
          {getFieldDecorator('avatar', {
            initialValue: user.avatar
          })(this.renderUploadButton())}
        </Form.Item>

        <Form.Item {...formItemLayout} label="First Name">
          {getFieldDecorator('firstName', {
            initialValue: user.firstName,
            rules: [
              {
                required: true,
                message: 'This field is required.'
              }
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Last Name">
          {getFieldDecorator('lastName', {
            initialValue: user.lastName,
            rules: [
              {
                required: true,
                message: 'This field is required.'
              }
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Email">
          {getFieldDecorator('email', {
            initialValue: user.email,
            rules: [
              {
                type: 'email',
                message: 'This field is a email.'
              },
              {
                required: true,
                message: 'This field is required.'
              }
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item {...formItemLayout} label="Role">
          {getFieldDecorator('roleId', {
            initialValue: user.role ? user.role.id : '',
            rules: [
              {
                required: true,
                message: 'Role is required.'
              }
            ]
          })(this.buildSelectRole(user.role))}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Phone">
          {getFieldDecorator('phone', {
            initialValue: user.phone,
            rules: []
          })(<Input />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Birth Day">
          {getFieldDecorator('birthDay', {
            initialValue: user.birthDay ? moment(user.birthDay) : '',
            rules: []
          })(<DatePicker />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Languages Supported">
          {getFieldDecorator('languages', {
            initialValue: user.languages,
            rules: []
          })(<Input />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Location">
          {getFieldDecorator('location', {
            initialValue: user.location,
            rules: []
          })(<Input />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Experiences">
          {getFieldDecorator('experiences', {
            initialValue: user.experiences,
            rules: []
          })(<TextArea rows={8} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Latitude">
          {getFieldDecorator('latitude', {
            initialValue: user.latitude,
            rules: []
          })(<InputNumber style={{width: 300}} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Longitude">
          {getFieldDecorator('longitude', {
            initialValue: user.longitude,
            rules: []
          })(<InputNumber style={{width: 300}} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Country Code">
          {getFieldDecorator('countryCode', {
            initialValue: user.countryCode,
            rules: []
          })(<Input />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Review by owner">
          {getFieldDecorator('review_by_owner', {
            initialValue: user.reviewByOwner,
            rules: []
          })(<InputNumber min={0} max={5} step={0.1} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Review by guest">
          {getFieldDecorator('review_by_guest', {
            initialValue: user.reviewByGuest,
            rules: []
          })(<InputNumber min={0} max={5} step={0.1} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Speed Response">
          {getFieldDecorator('speed_response', {
            initialValue: user.speedResponse,
            rules: []
          })(<InputNumber min={0} step={0.1} />)}
        </Form.Item>

        <Form.Item {...formItemLayout} label="Number Listings">
          {getFieldDecorator('number_listings', {
            initialValue: user.numberListings,
            rules: []
          })(<InputNumber min={0} />)}
        </Form.Item>

        <ReactMapGL
          {...viewport}
          mapboxApiAccessToken={MAPBOX_TOKEN}
          onViewportChange={(v: any) => this.updateViewport(v)}
        >
          <div style={{position: 'absolute', right: 30, bottom: 30}}>
            <NavigationControl onViewportChange={this.updateViewport} />
          </div>
          <Marker
            draggable={true}
            latitude={this.state.latitude}
            longitude={this.state.longitude}
            onDragEnd={this.handleDragEndMarker}
          >
            <Icon
              type="environment"
              style={{color: 'red', fontSize: '30px'}}
            />
          </Marker>
        </ReactMapGL>

        <Form.Item {...formItemLayout}>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </Form.Item>
      </Form>
    );
  }

  renderLoading() {
    return (
      <div style={{margin: 'auto'}}>
        <Button shape="circle" loading={true} />
      </div>
    );
  }
  render() {
    const {isLoading} = this.props.userDetail;
    return (
      <React.Fragment>
        <Helmet>
          <title>User Edit</title>
        </Helmet>
        <Layout>
          <Main>
            <Card>
              <CardHeader>User Detail</CardHeader>
              <CardBody>
                {isLoading ? this.renderLoading() : this.renderFormEdit()}
              </CardBody>
            </Card>
          </Main>
        </Layout>
      </React.Fragment>
    );
  }
}

const EditUser = Form.create()(EditUserForm);
export default EditUser;



// WEBPACK FOOTER //
// ./src/pages/EditUser/EditUser.tsx